import isEmpty from 'lodash/isEmpty'

export function toQueryParams(obj?: Record<string, string | number | boolean | Date | string[]>): string {
  if (typeof obj !== 'object' || obj === null || Array.isArray(obj) || isEmpty(obj)) {
    return ''
  }

  const params = new URLSearchParams()
  Object.entries(obj).forEach(([key, value]) => {
    //skip null or undefined values
    if (value === null || value === undefined) return

    //if the type is date, should be convert to ISO string
    if (value instanceof Date) {
      params.set(key, value.toISOString())
      return
    }

    if (Array.isArray(value)) {
      params.set(key, value.join(','))
      return
    }

    params.set(key, String(value))
  })

  return params.toString()
}
